import { Space, Spin, Typography } from 'antd';
import ReactSignatureCanvas from 'react-signature-canvas';
import { useState } from 'react';
import './styles.less';

interface SignatureFieldProps {
  isLoading: boolean;
  onCancel: () => void;
  onChange: (sigPadReturn?: {
    signature: string;
    dataType?: string;
    extension?: string;
    response: Response;
    blob: Blob;
    file: File;
  }) => void;
  canvasProps?: React.CanvasHTMLAttributes<HTMLCanvasElement>;
  style?: React.CSSProperties;
}

export default function SignatureField({
  onCancel,
  onChange,
  isLoading,
  canvasProps,
  style,
}: SignatureFieldProps) {
  const [sigPad, setSigPad] = useState<ReactSignatureCanvas | null>(null);

  const handleSigPadReturn = async () => {
    if (!sigPad?.isEmpty() && sigPad?.getTrimmedCanvas()) {
      const signature = sigPad?.getTrimmedCanvas().toDataURL('image/png');
      const dataType = signature?.match(/^data:(.+);base64/)?.[1];
      const extension = dataType?.split('/').at(-1)?.toLowerCase();
      const response = await fetch(signature);
      const blob = await response.blob();
      const file = new File(
        [blob],
        `${new Date().toISOString()}.${extension}`,
        {
          type: dataType,
        },
      );
      return {
        signature,
        dataType,
        extension,
        response,
        blob,
        file,
      };
    } else {
      return undefined;
    }
  };

  return (
    <>
      <ReactSignatureCanvas
        canvasProps={{
          className: 'checklist-signature hidden-print',
          ...canvasProps,
        }}
        ref={(ref) => setSigPad(ref)}
      />
      <Space
        style={{
          width: '60%',
          justifyContent: 'space-between',
          ...style,
        }}
        className="hidden-print"
      >
        <Typography.Link strong onClick={onCancel}>
          Cancelar
        </Typography.Link>
        <Typography.Link
          strong
          style={{ color: 'red' }}
          onClick={() => {
            sigPad?.clear();
            onChange(undefined);
          }}
        >
          Limpar
        </Typography.Link>
        <Typography.Link
          disabled={isLoading}
          strong
          style={{ color: isLoading ? 'lightGreen' : 'green' }}
          onClick={async () => {
            onChange(await handleSigPadReturn());
          }}
        >
          {isLoading && <Spin style={{ marginRight: '5px' }} size="small" />}
          Salvar
        </Typography.Link>
      </Space>
    </>
  );
}
